import { render, staticRenderFns } from "./BudgetMetrics.vue?vue&type=template&id=7134a7ef&scoped=true&"
import script from "./BudgetMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetMetrics.vue?vue&type=style&index=0&id=7134a7ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134a7ef",
  null
  
)

export default component.exports